/**
 * main.js — app bootstrap only.
 * Does not export the app instance for other modules to import
 * (use `@/http/appBridge` setApp/getApp instead).
 */
import App from './App.vue'
import moment from 'moment'
import { createApp } from 'vue'
import { registerPlugins } from '@/plugins'
import { installGlobals } from '@/plugins/globals'
import { installFilters } from '@/plugins/filters'
import { setApp } from '@/http/appBridge'
import { version } from './../package.json'

const app = createApp(App)

// Bridge first so HTTP/router can resolve globals once installed
setApp(app)

app.config.globalProperties.$moment = moment
app.config.globalProperties.version = version
installFilters(app)

registerPlugins(app)
installGlobals(app)

app.mount('#app')

// Default export kept only for rare legacy consumers / tests.
// Prefer setApp/getApp for runtime access.
export default app
